import { VariableType } from 'json-to-graphql-query';

import { SystemMessage } from '@/interfaces/systemMessage';
import { EntityResource } from './entity.resource';
/**
 * Resource powiadomień systemowych
 *
 * @export
 * @class SystemMessageResource
 * @extends {EntityResource<SystemMessage>}
 */
export class SystemMessageResource extends EntityResource<SystemMessage> {
  public getFields = {
    id: true,
    name: true,
    body: true,
    entityType: true,
    entityId: true,
    receiverId: true,
    visibilityDate: true
  };

  public listFields = {
    id: true,
    name: true,
    visibilityDate: true,
    read: true,
    body: true,
    entityType: true,
    entityId: true
  };

  public listVariables = { filters: 'MessageFilters' };

  constructor() {
    super({
      entityName: 'message'
    });
  }

  /**
   * Odczytanie powiadomienia
   *
   * @param {number} id
   * @returns {Promise<number>}
   * @memberof SystemMessageResource
   */
  public read(id: number): Promise<number> {
    const mutation = this.prepareOptions({
      mutation: {
        __variables: { id: 'Int!' },
        messageRead: {
          __args: {
            id: new VariableType('id')
          }
        }
      }
    });
    return this.mutation({ mutation, variables: { id } }, 'messageRead');
  }
}

export const systemMessageResource = new SystemMessageResource();
